
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity/v2",
      function () {
        return require("private-next-pages/liquidity/v2/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liquidity/v2"])
      });
    }
  